import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from '../SearchWidget.module.scss';
import {connect} from "react-redux";
import submitBtnImgPath from "../../../assets/media/submitIcon.svg";
import WindowEventWatcher from "../../Common/WindowEventWatcher";
import Field from "../../../tools/Field";
import {withTranslation} from "react-i18next";
import {APP_CONFIGS} from "../../../config/configs";
import BookFlightOptions from "../BookFlight/BookFlightOptions/BookFlightOptions";
import responsiveDefinitions from "../../../hoc/ResponsiveDefinitions/ResponsiveDefinitions";

const LoginForm = ({lang, formRef, Styles, t}) => {

    const [fields, setFields] = useState({
        email: new Field('email', '', '', v => /^\S*$/g.test(v), v => /^.+$/g.test(v)),
        pass: new Field('pass', '', '', v => /^.*$/g.test(v), v => /^.*$/g.test(v)),
    });

    const handleSubmit = e => {
        const validation = Field.validateAllFields(fields);
        setFields({...validation.fields});
        if (validation.isAllValid) {
            formRef.current.submit();
        }
    };

    const onChange = (field, e) => {
        const value = e.target.value;

        if (field.validate(value, true).getIsInvalid()) {
            setTimeout(() => {
                field.validate();
                setFields({...fields, [field.key]: {...field}});
            }, 1000);
        } else {
            field.setValue(value);
        }

        setFields({...fields, [field.key]: {...field}});
    };

    const onBlurHandler = (field, e) => {
        field.validate();
        setFields({...fields, [field.key]: {...field}});
    };

    const keyDownHandler = e => {
        const code = e.code ? e.code : e.key;

        switch (code) {
            case 'NumpadEnter':
            case 'Enter':
                handleSubmit();
                break;
            default:
                return;
        }

        e.preventDefault();
        e.stopPropagation();
    };

    const submitClasses = [styles.loginFormSubmitBtnContainer];
    if (!(fields.email.getIsValid() && fields.pass.getIsValid())) submitClasses.push(styles.loginFormSubmitBtnDisabled);

    const isMobile = !Styles.matches(false, false);

    return (
        <div className={styles.loginFormContainer}>
            <WindowEventWatcher handlerFn={keyDownHandler} eventName={'keydown'}/>
            <div className={styles.genericFormMessageLeft}>
                {t('Please login to book your trip')}.<br/>
                {t("Don't have a SATA IMAGINE account yet?")}<br/>
                <a href={'/'+lang+'/user/register'} target={'_blank'}>{t('Create an account')}</a> {t('and earn miles')}.
            </div>
            <form method='POST' action={`${APP_CONFIGS.CURRENT_PATH}?destination=${APP_CONFIGS.CURRENT_PATH}`} ref={formRef}>
                <input type='hidden' name='form_id' value='user_login_form'/>
                <input type='hidden' name='form_build_id' value={window.loginFormId || ''}/>
                <div className={styles.loginFormInputContainer}>
                    <label htmlFor={'username-field'}>
                        {t('Member ID or e-mail')}
                    </label>
                    <div className={styles.loginFormInputContainerInner}>
                        <input
                            autoFocus={true}
                            autoCorrect='none'
                            autoCapitalize='none'
                            spellCheck='none'
                            id={'username-field'}
                            name='name'
                            size={15}
                            maxLength={60}
                            type='email'
                            placeholder={t('Member ID or e-mail')}
                            className={fields.email.getIsInvalid() ? styles.genericFormInvalidInput : ''}
                            value={fields.email.getValue()}
                            onChange={e => onChange(fields.email, e)}
                            onBlur={e => onBlurHandler(fields.email, e)}
                            required
                            aria-required/>
                            &nbsp;
                    </div>
                </div>
                <div className={styles.loginFormInputContainer}>
                    <label htmlFor={'pass-field'}>
                        {t('Password')}
                    </label>
                    <div className={styles.loginFormInputContainerInner}>
                        <input
                            autoCorrect='none'
                            autoCapitalize='none'
                            autoComplete='off'
                            spellCheck='none'
                            id={'pass-field'}
                            name='pass'
                            size={15}
                            maxLength={128}
                            className={fields.pass.getIsInvalid() ? styles.genericFormInvalidInput : ''}
                            value={fields.pass.getValue()}
                            onChange={e => onChange(fields.pass, e)}
                            onBlur={e => onBlurHandler(fields.pass, e)}
                            type='password'
                            placeholder={t('Password')}
                            required
                            aria-required/>
                        <a href={'/'+lang+'/user/password'} target={'_blank'}>{t('Reset your password')}</a>
                    </div>
                </div>
                <div className={styles.loginFormSubmitContainer}>
                    <BookFlightOptions display={isMobile} inlineStyles={{backgroundColor: 'transparent'}}/>
                    <div onClick={handleSubmit}
                         role={'button'}
                         className={submitClasses.join(' ')}
                         tabIndex={0}>
                        <img src={submitBtnImgPath} alt={'login submit btn'}/>
                    </div>
                </div>

            </form>
        </div>
    );
};

LoginForm.propTypes = {
    Styles: PropTypes.object,
    formRef: PropTypes.any,
    lang: PropTypes.string,
    t: PropTypes.func,
};

LoginForm.defaultProps = {
    Styles: {},
    formRef: React.createRef(),
    lang: 'en',
    t: s => s,
};

export default responsiveDefinitions(withTranslation()(connect(state => ({lang: state.common.lang}))(LoginForm)));

